// Who is on a Real Estate deal (ticket 206): the shared assignment chips and picker,
// pointed at the transaction. Adding or removing a person needs `loans.assign`.
import React from 'react';
import { useAuth } from '../AuthContext';
import { AssignmentPicker } from '../loan-file/shared/AssignmentPicker';
import { txAssignments } from './transactionAssignments';

export default function TransactionTeam({ transactionId }) {
  const auth = useAuth();
  const canAssign = (auth?.user?.permissions || []).includes('loans.assign');
  return (
    <div data-testid={`tx-team-${transactionId}`}>
      <div className="text-[10px] uppercase tracking-widest font-bold text-slate-500 mb-2">Team</div>
      <AssignmentPicker loanId={transactionId} client={txAssignments} canAssign={canAssign} title="Assign to this deal" />
    </div>
  );
}
